import React, {useState ,useEffect} from 'react'
import styles from './Header.module.css'

export default function Header() {
    const [text, setText] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setText(!text);
        }, 2500);
        return () => clearInterval(interval)
    }, [text]);
    return (
        <div className={styles.container}>
            <div className={styles.img}>
                <div className={styles.text_wrapper}>
                    <h1>Эрчим хүчний 

                    </h1>
                    <div className={styles.switch}> 
                        <h1 className={text ? styles.text_top : styles.text_mid}> хэмнэлт</h1>
                        <h1 className={!text ? styles.text_bot : styles.text_mid}> үр ашиг</h1>
                    </div>
                </div>
            </div>
        </div>
    )
}
